import { strapiFetch } from '../../entities/@api/Strapi';
import { isFetchResultSuccessful } from '../../entities/FetchResult/FetchResult';
import { AppRoute, appRoutes } from '../../entities/Routing/Routing';
import { SpaceItemResponse } from '../../entities/Space/Space';
import { generateSpaceQuery } from '../../entities/Space/SpaceRequests';
import { transformToSpace } from '../../entities/Space/SpaceTransformers';
import { sortByOrder } from '../../helpers/sort';
import trans from '../../helpers/trans';
import { ReduxFetchAction } from '../defaults';
import {
    setBreadcrumbs,
    setCategories,
    setError,
    setHasFetched,
    setIsLoading,
    setIsSuccessful,
    setSpace,
    setSpaces,
} from './spaceSlice';

export const fetchSpaces: ReduxFetchAction = () => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setHasFetched(false));
    dispatch(setIsSuccessful(false));
    dispatch(setError(''));
    dispatch(setSpaces([]));

    try {
        const query = generateSpaceQuery();

        const spacesResponse = await strapiFetch<SpaceItemResponse>(`/spaces?${query}`);

        if (!isFetchResultSuccessful(spacesResponse)) {
            dispatch(setError(spacesResponse.error));
            return;
        }

        const { data: spacesData } = spacesResponse.data;

        const spaces = spacesData
            ? spacesData.map(transformToSpace)
            : [];

        const sortedSpaces = spaces.sort(sortByOrder);

        dispatch(setSpaces(sortedSpaces));
        dispatch(setIsSuccessful(true));
    } catch (error) {
        console.error('[fetchSpaces]', error);
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setHasFetched(true));
    }
};

export const fetchSpace: ReduxFetchAction<string> = slug => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setHasFetched(false));
    dispatch(setIsSuccessful(false));
    dispatch(setError(''));
    dispatch(setSpace(undefined));

    try {
        const query = generateSpaceQuery(slug);

        const spacesResponse = await strapiFetch<SpaceItemResponse>(`/spaces?${query}`);

        if (!isFetchResultSuccessful(spacesResponse)) {
            dispatch(setError(spacesResponse.error));
            return;
        }

        const { data: spaceData } = spacesResponse.data;

        const spaceResource = spaceData
            ? spaceData[0]
            : undefined;

        const space = spaceResource
            ? transformToSpace(spaceResource)
            : undefined;

        const spaceOverviewLink = {
            href: trans(appRoutes[AppRoute.spacesOverview].path),
            label: trans(appRoutes[AppRoute.spacesOverview].label),
        };

        const spaceLink = space
            ? {
                href: `${trans(appRoutes[AppRoute.spacesOverview].path)}/${space.slug}`,
                label: space.name,
            }
            : undefined;

        const breadcrumbs = spaceLink
            ? [spaceOverviewLink, spaceLink]
            : [spaceOverviewLink];

        dispatch(setBreadcrumbs(breadcrumbs));

        dispatch(setSpace(space));
        dispatch(setCategories(space?.categories || []));
        dispatch(setIsSuccessful(true));
    } catch (error) {
        console.error('[fetchSpace]', error);
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setHasFetched(true));
    }
};
